import { Box, IconButton } from "@mui/material";
import { useState } from "react";

import { MediaCardProps } from "../../../../types/components/props.type";
import { PlayIconButton } from "../../../../assets/icons/create-feed";

const MediaCard = ({ item, index, extraMediaCount, handleClickOnMedia }: MediaCardProps) => {
  const isLastVisible = index === 4 && extraMediaCount > 0;
  const [hasError, setHasError] = useState(false);

  return (
    <Box
      onClick={handleClickOnMedia}
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        cursor: "pointer",
        bgcolor: hasError ? "rgba(0, 0, 0, 0.1)" : "transparent",
      }}
    >
      {!hasError && (
        <img
          src={item.type === "IMAGE" ? item.url : item.thumbnail || ""}
          alt={`media-${item.id}`}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          loading="lazy"
          onError={() => setHasError(true)}
        />
      )}
      {item.type === "VIDEO" && (
        <IconButton
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            padding: 0,
          }}
        >
          <PlayIconButton />
        </IconButton>
      )}
      {isLastVisible && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.6)",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Montserrat",
            fontSize: "48px",
            fontStyle: "normal",
            fontWeight: 500,
          }}
        >
          +{extraMediaCount}
        </Box>
      )}
    </Box>
  );
};

export default MediaCard;
